export default __webpack_public_path__ + "static/media/walletFilledIcon.07bb8cef.svg";